import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Route protection wrapper for Platform Admin routes
 * Redirects non-Platform Admins to unauthorized page
 * Handles authorization errors gracefully
 * Requirements: 10.5, 12.3
 */
interface PlatformAdminRouteProps {
  children: React.ReactNode;
}

const PlatformAdminRoute: React.FC<PlatformAdminRouteProps> = ({ children }) => {
  const { currentUser, loading, isAuthorizationError, isPlatformAdmin } = useAuth();

  // Show loading state while fetching user
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Redirect on authorization errors
  if (isAuthorizationError) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Redirect if not Platform Admin
  if (!currentUser || !isPlatformAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default PlatformAdminRoute;
